import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/offers/rent-object-bookings/${formData.rentObjectBookingId}`, formData);
  },
  async createMultiple(formData) {
    return axios.post(`/offers/create-multiple`, formData);
  },
  async findAll(formData) {
    return axios.get(`/offers/rent-object-bookings/${formData.rentObjectBookingId}`);
  },
  async getAttachement(formData) {
    return axios.get(`/offers/${formData.id}/pdf`, { responseType: 'arraybuffer' });
  },
  async delete({ id }) {
    return axios.delete(`/offers/${id}`);
  },
  async search(payload) {
    let url = `/offers/search?search=${payload.searchString}`
    return axios.get(url);
  },
};